import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import ListHeader from '@/common/components/ListHeader'
import Table from '@/common/components/Table'
import TextField from '@/common/components/TextField'
import { useClientRoles } from '@/common/hooks/queries/useClientRoles'
import useDebounce from '@/common/hooks/useDebounce'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { RoleData, RoleTableItem } from '@/common/types/roles'
import { ClientRolesTransformer } from '@/features/clientRoles/services/clientRolesTransformer'
import { defaultColumns } from '@/features/tcardRoles/constants/columns.constant'
import { SearchIcon, WandSparklesIcon } from 'lucide-react'

const ClientRoles = () => {
  const { filterParams, setFilterParams } = useFilterParams()

  const [search, setSearch] = useDebounce(filterParams.search || '')

  const {
    data: roles,
    meta,
    isPending: isPendingRoles,
    isLoading: isLoadingRoles,
    error: rolesError = {} as any,
    refetch: refetchRoles,
  } = useClientRoles({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<RoleData[], RoleTableItem[]>({
      transformer: ClientRolesTransformer.tableTransformer('Admin::Client::Roles::Show'),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<WandSparklesIcon className="w-10 h-10" strokeWidth={1} />}
        title="Cargos e permissões - Cliente"
        createButtonText="Novo cargo"
        operationKlassToCheckPermission='Admin::Client::Roles::Create'
        disableCreateButton={isPendingRoles || rolesError?.status === 403}
      />
      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={rolesError?.status}
        refetchFunction={refetchRoles}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              value={filterParams.search || ''}
              onChange={(e: any) => {
                setSearch(e.target?.value)
                setFilterParams((prev) => ({
                  ...prev,
                  search: e.target?.value,
                }))
              }}
            />
          </div>

          <Table
            className="max-h-[calc(100vh-204px)]"
            columns={defaultColumns}
            isLoadingData={isLoadingRoles}
            page={filterParams.page || 1}
            rows={roles}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}

export default ClientRoles
